<template>
    <div class="row document-tab d-flex justify-content-center">
        <div class="col-12 col-lg-10 col-xl-8">
            <section id="subscription-uploaded-documents">
                <subscription-uploaded-documents
                    :subscription-data="subscriptionData"
                    :user-uploads="this.filteredDocuments.userUploads"
                ></subscription-uploaded-documents>
            </section>

            <subscription-document-list
                :title="$t('cdb.subscriptions.documentType.finalInvoice')"
                :documents="filteredDocuments.finalInvoice"
                v-if="filteredDocuments.finalInvoice.length"
                class="mb-3"
            ></subscription-document-list>

            <section id="subscription-document-list">
                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.invoices')"
                    :documents="filteredDocuments.invoice"
                    v-if="filteredDocuments.invoice.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.damageReports')"
                    :documents="this.filteredDocuments.damageReport"
                    v-if="this.filteredDocuments.damageReport.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.handoverReport')"
                    :documents="filteredDocuments.handoverReport"
                    v-if="filteredDocuments.handoverReport.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.returnReports')"
                    :documents="filteredDocuments.returnReport"
                    v-if="filteredDocuments.returnReport.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.tickets')"
                    :documents="filteredDocuments.ticket"
                    v-if="filteredDocuments.ticket.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.speedTrapReports')"
                    :documents="filteredDocuments.speedTrapReport"
                    v-if="filteredDocuments.speedTrapReport.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.misc')"
                    :documents="filteredDocuments.misc"
                    v-if="filteredDocuments.misc.length"
                    class="mb-3"
                ></subscription-document-list>

                <subscription-document-list
                    :title="$t('cdb.subscriptions.documentType.proofOfDiscount')"
                    :documents="filteredDocuments.proofOfDiscount"
                    v-if="filteredDocuments.proofOfDiscount.length"
                    class="mb-3"
                ></subscription-document-list>
            </section>
        </div>
    </div>
</template>

<script>
import SubscriptionUploadedDocuments from "../molecules/SubscriptionUploadedDocuments.vue";
import SubscriptionDocumentList from "../molecules/SubscriptionDocumentList.vue";
import { EventBus } from "../../event-bus"

export default {
    name: 'CdbTabDocuments',
    components: {
        SubscriptionDocumentList,
        SubscriptionUploadedDocuments
    },
    props: {
        subscriptionData: null
    },
    data() {
        return {
            documents: null,
            filteredDocuments: {
                userUploads: [],
                invoice: [],
                damageReport: [],
                handoverReport: [],
                returnReport: [],
                ticket: [],
                speedTrapReport: [],
                misc: [],
                finalInvoice: [],
                proofOfDiscount: [],
            }
        }
    },
    methods: {
      getDocuments(){
          this.$axios.put('api/v1/dashboard/subscription_documents', {
                  subscription_uuid: this.subscriptionData.uuid
          }).then(response => {
              this.documents = response.data
              this.filteredDocuments.userUploads = this.documents.filter(d => d.uploaded_by_user === 1)
              this.filteredDocuments.invoice = this.documents.filter(d => d.document_type === 'INVOICE' && d.uploaded_by_user === 0)
              this.filteredDocuments.damageReport = this.documents.filter(d => d.document_type === 'DAMAGE_REPORT' && d.uploaded_by_user === 0)
              this.filteredDocuments.handoverReport = this.documents.filter(d => d.document_type === 'HANDOVER_REPORT' && d.uploaded_by_user === 0)
              this.filteredDocuments.returnReport = this.documents.filter(d => d.document_type === 'RETURN_REPORT' && d.uploaded_by_user === 0)
              this.filteredDocuments.ticket = this.documents.filter(d => d.document_type === 'TICKET' && d.uploaded_by_user === 0)
              this.filteredDocuments.speedTrapReport = this.documents.filter(d => d.document_type === 'SPEED_TRAP_REPORT' && d.uploaded_by_user === 0)
              this.filteredDocuments.misc = this.documents.filter(d => d.document_type === 'MISC' && d.uploaded_by_user === 0)
              this.filteredDocuments.finalInvoice = this.documents.filter(d => d.document_type === 'FINALINVOICE' && d.uploaded_by_user === 0)
              this.filteredDocuments.proofOfDiscount = this.documents.filter(d => d.document_type === 'PROOF_OF_DISCOUNT' && d.uploaded_by_user === 0)

              this.isLoading = false
          }).catch(error => {
              this.error = error.response.data.message
          });
      },
      handleDownloadClicked(event, link) {
            const whitelabel_uuid = this.$root.user.state.data.whitelabel_uuid
            const subscription_uuid = this.subscriptionData.uuid
            this.$axios.get('api/v1/dashboard/get_document', {
                params: {
                    link: link,
                    subscription_uuid: subscription_uuid,
                    whitelabel_uuid: whitelabel_uuid
                }

            }).then(response => {
                if (response.data && response.data.file) {
                    this.downloadFile(response.data.file);
                }
            }).catch(error => {
                this.error = error.response.data.message
            });
      },
      downloadFile(link) {
          window.open(link, '_blank');
      }

    },
    mounted() {
        this.getDocuments()
        EventBus.$on('cdb-reload-documents', this.getDocuments);
    },

    created() {
        EventBus.$on('download-clicked', this.handleDownloadClicked);
    },
    beforeDestroy() {
        EventBus.$off('download-clicked', this.handleDownloadClicked);
    },
}
</script>
